export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  // {
  //   url: "/",
  //   name: "신규 사업장 등록 요청",
  //   icon: "",
  //   activeCode: "",
  //   submenu: [
  //     // {
  //     //   url: "/tab/300",
  //     //   name: "직접수행 사업장",
  //     //   icon: "w-line",
  //     //   activeCode: "",
  //     //   groupName: ['300'],
  //     // },
  //     {
  //       url: "/tab/301",
  //       name: "도급·용역·위탁 사업장",
  //       icon: "w-line",
  //       activeCode: "",
  //       groupName: ["301"],
  //     },
  //     // {
  //     //   url: "/tab/302",
  //     //   name: "발주 사업장",
  //     //   icon: "w-line",
  //     //   activeCode: "",
  //     //   groupName: ["302"],
  //     // },
  //     // {
  //     //   url: "/tab/303",
  //     //   name: "시설물",
  //     //   icon: "w-line",
  //     //   activeCode: "",
  //     //   groupName: ["303"],
  //     // },
  //   ],
  // },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-subcontract",
        name: "도급·용역·위탁 사업장",
        icon: "w-line",
        activeCode: "field-workplace-subcontract",
      },
    ],
  },
  {
    url: "/",
    name: "의무 이행사항 점검(반기1회)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/722",
        name: "관리감독자",
        icon: "w-line",
        activeCode: "",
        groupName: ["722", "543"],
      },
    ]
  },
  {
    url: "/",
    name: "안전보건 협의체",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/701/page",
        name: "협의체 설명",
        icon: "w-line",
        activeCode: "",
        groupName: ["701"],
      },
      {
        url: "/tab/713",
        name: "협의체 구성",
        icon: "w-line",
        activeCode: "",
        groupName: ["713"],
      },
      {
        url: "/tab/703",
        name: "협의체 운영 일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["703"],
      },
    ]
  },
  {
    url: "/",
    name: "안전보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/_106/page",
        name: "부서별 안전보건 예산(A형)",
        icon: "w-line",
        activeCode: "",
        groupName: ["106/page"],
      },
      {
        url: "/tab/106",
        name: "안전보건 예산(A형)",
        icon: "w-line",
        activeCode: "",
        groupName: ["106"],
      },
    ],
  },
  {
    url: "/",
    name: "교육 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/107",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["107"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "w-line",
        activeCode: "",
        groupName: ["132"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/700/page",
        name: "도급분야 위험성평가 설명",
        icon: "w-line",
        activeCode: "",
        groupName: ["700"],
      },
      {
        url: "/tab/714",
        name: "위험성평가(도급자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["714"],
      },
      {
        url: "/tab/715",
        name: "위험성평가(수급자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["715"],
      },
    ],
  },
  {
    url: "/",
    name: "안전작업계획(허가)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/246",
        name: "안전작업계획서(고위험작업)",
        icon: "w-line",
        activeCode: "",
        groupName: ["246"],
      },
      {
        url: "/tab/257",
        name: "작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["257"],
      },
    ],
  },
  {
    url: "/",
    name: "안전보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/699/page",
        name: "안전보건점검 설명",
        icon: "w-line",
        activeCode: "",
        groupName: ["699"],
      },
      {
        url: '/tab/704',
        name: '안전보건준수서약서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['704'],
      },
      {
        url: "/tab/707",
        name: "순회점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["707"],
      },
      {
        url: "/tab/708",
        name: "합동점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["708"],
      },
      {
        url: "/tab/709",
        name: "기타점검",
        icon: "w-line",
        activeCode: "",
        groupName: ["709"],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/116/page",
        name: "(재해발생) 산업재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["116"],
      },
      {
        url: "/tab/238/page",
        name: "(재해발생) 비상조치 및 처리 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["238"],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·자체평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/346",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["346"],
      },
      {
        url: '/tab/307',
        name: '안전사고 발생 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['307'],
      },
      {
        url: '/tab/308',
        name: '재발방지 조치 보고서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['308'],
      },
    ],
  },
  {
    url: "/",
    name: "발주공사",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: '/tab/702/page',
        name: '발주공사 의무사항 설명',
        icon: 'w-line',
        activeCode: '',
        groupName: ['702'],
      },
      {
        url: '/tab/705',
        name: '안전보건준수서약서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['705'],
      },
      {
        url: '/tab/706',
        name: '안전보건대장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['706'],
      },
      {
        url: '/tab/710',
        name: '안전보건조정자',
        icon: 'w-line',
        activeCode: '',
        groupName: ['710'],
      },
      {
        url: '/tab/711',
        name: '건설재해예방 기술지도 계약',
        icon: 'w-line',
        activeCode: '',
        groupName: ['711'],
      },
      {
        url: '/tab/712',
        name: '산업안전보건관리비',
        icon: 'w-line',
        activeCode: '',
        groupName: ['712'],
      },
    ]
  },
  {
    url: "/",
    name: "수급업체 안전보건 수준평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: '/tab/889',
        name: '평가표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['889'],
      },
    ]
  },
  {
    url: "/",
    name: "자료실",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/342",
        name: "자료실",
        activeCode: "filelibrary-342",
        icon: "w-line",
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "중대재해 발생 사례 공유",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ['16'],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ['18'],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ['19'],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ['17'],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ['90'],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ['91'],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ['93'],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ['94'],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ['95'],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ['96'],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ['97'],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ['98'],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ['92'],
          },
        ],
      },
    ],
  },
];
